var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Field } from 'react-final-form';
import { StyledInputLabel, InputElementHeading } from '../elements';
import { Input } from '../input/input';
import { isPhoneValid } from '../../validators';
import AccessibilityHelper from '../accessibilityHelper';
import elementStyles from '../elements.module.scss';
var InputPhone = function (_a) {
    var id = _a.id, label = _a.label, name = _a.name, hint = _a.hint, input = _a.input, testId = _a.testId, meta = _a.meta, required = _a.required, placeholder = _a.placeholder, readOnly = _a.readOnly, cfg = _a.cfg;
    var helper = new AccessibilityHelper(name, !!label, !!hint);
    return (React.createElement(StyledInputLabel, { isError: meta && meta.touched && meta.error, cfg: Object.assign({ mt: 1 }, cfg) },
        React.createElement(InputElementHeading, { label: label, required: required, hint: hint, meta: meta, accessibilityHelper: helper }),
        React.createElement(Input, __assign({ id: id, autoComplete: "tel", className: elementStyles.phoneInput, testId: testId, label: label, placeholder: placeholder, readOnly: readOnly, isError: meta && meta.touched && meta.error, required: required, accessibilityHelper: helper }, input, { type: "tel" }))));
};
export var FFInputPhone = function (fieldProps) {
    return (React.createElement(Field, __assign({}, fieldProps, { validate: isPhoneValid(fieldProps.errorEmptyValue, fieldProps.errorInvalidValue, fieldProps.required), render: function (props) { return React.createElement(InputPhone, __assign({}, props, fieldProps)); } })));
};
//# sourceMappingURL=phone.js.map